/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';

import SimpleRichTextContentful from 'bundles/coursera-plus-landing-page/components/SimpleRichTextContentful';
import {
  HIDDEN_SLUG_FOR_DEFAULT_LANDING_PAGE,
  landingPageTypeChoices,
} from 'bundles/coursera-plus-landing-page/contentful/constants';
import { useLandingPageExtended } from 'bundles/coursera-plus-landing-page/contentfulData/useLandingPageData';
import { getCopy } from 'bundles/coursera-plus/utils/courseraPlusUtils';

const styles = {
  heroText: css`
    font-weight: normal;
  `,
};

const HeroText = () => {
  const landingPageExtended = useLandingPageExtended();
  const { userHasCourseraPlusFreeTrial, isCourseraPlusOwner, isCourseraLiteOwner } = landingPageExtended;
  const { heroTextBig, heroTextMedium2, heroTextSmall2, landingPageType, slug } = landingPageExtended.landingPage;
  const shouldDisplayHeroTextFromContentful = landingPageType === landingPageTypeChoices.COMPUTER_SCIENCE_COLLECTION;

  const heroTextFromContentful = (
    <div>
      {heroTextBig && (
        <Typography2 data-testid="hero-text-big" variant="titleMedium" component="h2" css={styles.heroText}>
          {heroTextBig}
        </Typography2>
      )}
      {heroTextMedium2 && (
        <Typography2 data-testid="hero-text-medium" variant="titleSmall" component="h2" css={styles.heroText}>
          <SimpleRichTextContentful richText={heroTextMedium2} />
        </Typography2>
      )}
      {heroTextSmall2 && (
        <Typography2 data-testid="hero-text-small" variant="subtitleLarge" component="h2" css={styles.heroText}>
          <SimpleRichTextContentful richText={heroTextSmall2} />
        </Typography2>
      )}
    </div>
  );

  if (shouldDisplayHeroTextFromContentful) {
    return heroTextFromContentful;
  }

  // Hero text for Coursera Plus landing pages. For users who have exhausted free trial
  // we should only display the default hero text if they're on the default landing page.
  // for other marketing pages, the copy will come from Contentful
  if (
    (!userHasCourseraPlusFreeTrial && slug === HIDDEN_SLUG_FOR_DEFAULT_LANDING_PAGE) ||
    isCourseraPlusOwner ||
    isCourseraLiteOwner
  ) {
    const { headlineV4, numberOfProducts } = getCopy();
    return (
      <Typography2 variant="titleSmall" component="h2">
        <FormattedMessage message={headlineV4} numberOfProducts={numberOfProducts} />
      </Typography2>
    );
  }

  return heroTextFromContentful;
};

export default HeroText;
